const API_URL = process.env.REACT_APP_API_URL || 'https://api.ulitar.com';

export function mapProduct(p, idx = 0) {
  const price = typeof p.price === 'number' ? p.price : parseFloat(p.price) || 0;
  const discount = typeof p.discount === 'number' ? p.discount : 0;
  const oldPrice = discount > 0 ? Math.round((price / (1 - discount / 100)) * 100) / 100 : price;
  return {
    id: p._id || String(idx + 1),
    slug: p.slug || p._id,
    img: p.img || 'assets/images/thumbs/product-img1.png',
    title: p.title || '',
    price,
    oldPrice,
    discount,
    category: p.category || 'General',
    brand: p.brand?.name || '',
    rating: p.rating ? (p.rating.total / Math.max(p.rating.count, 1)).toFixed(1) : '4.5',
  };
}

export async function fetchProducts() {
  try {
    const host = typeof window !== 'undefined' ? window.location.hostname : 'marketpro.orbitcart.cloud';
    const res = await fetch(`${API_URL}/api/product/all?limit=100`, {
      headers: { 'X-Store-Host': host, 'X-Platform': 'ulitar' },
    });
    if (!res.ok) return null;
    const json = await res.json();
    return (json.data || []).map(mapProduct);
  } catch {
    return null;
  }
}
